import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef, useState, useCallback, useImperativeHandle, useEffect, useMemo, createRef } from 'react';
import { ModalPane, Card, Flex, Button, Input } from '@costar/theme-ui';
import { inputStyles, buttonStyles } from './shared-style.esm.js';
import { same } from '../../../utilities/same.esm.js';
import { normalizeLayoutName } from '../../../utilities/normalize-layout-name.esm.js';
import { layoutNameIsValid } from '../../../utilities/layout-name-is-valid.esm.js';
import { ConfirmOverrideDialog } from '../confirm-override-dialog/confirm-override-dialog.esm.js';
import { oneOf } from '../../../utilities/one-of.esm.js';

var SaveAsDialog = /*#__PURE__*/forwardRef(function (props, ref) {
  var _confirmOverrideDialo2;
  var otherLayoutNames = props.otherLayoutNames,
    onConfirm = props.onConfirm,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'sm' : _props$fontSize;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var open = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var close = useCallback(function () {
    return setIsOpen(false);
  }, []);
  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  });
  var inputRef = /*#__PURE__*/createRef();
  var confirmOverrideDialog = /*#__PURE__*/createRef();
  var _useState3 = useState(normalizeLayoutName(props.layoutName)),
    _useState4 = _slicedToArray(_useState3, 2),
    layoutName = _useState4[0],
    setLayoutName = _useState4[1];
  useEffect(function () {
    setLayoutName(normalizeLayoutName(props.layoutName));
  }, [props.layoutName]);
  useEffect(function () {
    if (inputRef.current) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [inputRef]);
  var isValid = useMemo(function () {
    return layoutNameIsValid(layoutName, props.predefinedLayoutNames) && !same(props.layoutName, layoutName);
  }, [layoutName, props.layoutName, props.predefinedLayoutNames]);
  var saveDialogLayoutNameChange = useCallback(function (e) {
    setLayoutName(e.target.value);
  }, []);
  var confirmClick = useCallback(function () {
    onConfirm(normalizeLayoutName(layoutName));
    setIsOpen(false);
  }, [layoutName, onConfirm]);
  var saveClick = useCallback(function () {
    if (oneOf(otherLayoutNames, layoutName)) {
      var _confirmOverrideDialo;
      (_confirmOverrideDialo = confirmOverrideDialog.current) === null || _confirmOverrideDialo === void 0 ? void 0 : _confirmOverrideDialo.open();
    } else {
      confirmClick();
    }
  }, [confirmClick, confirmOverrideDialog, layoutName, otherLayoutNames]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfirmOverrideDialog, {
    ref: confirmOverrideDialog,
    resources: props.confirmOverrideResources,
    layoutName: layoutName,
    onConfirm: confirmClick,
    fontSize: fontSize
  }), (_confirmOverrideDialo2 = confirmOverrideDialog.current) !== null && _confirmOverrideDialo2 !== void 0 && _confirmOverrideDialo2.isOpen ? null : /*#__PURE__*/React.createElement(ModalPane, {
    "aria-describedby": "",
    "aria-labelledby": "",
    variant: "modal.cosmos",
    disablePortal: true,
    maxWidth: "578px",
    maxHeight: "100%",
    open: isOpen,
    onClose: close,
    useModalAsBackdrop: true,
    disableBackdropClick: true,
    fontSize: fontSize
  }, /*#__PURE__*/React.createElement(Card.Card, {
    useContext: true,
    variant: "card-modal",
    id: "save-dialog"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Card.Title, {
    color: "black",
    ellipsis: true
  }, props.saveAsResources.title()), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "neutral.dark",
    iconSize: "xl",
    iconTop: "close",
    onClick: close,
    p: "0",
    variant: "icon"
  }))), /*#__PURE__*/React.createElement(Card.Content, {
    p: "xl",
    pt: "0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: layoutName,
    placeholder: props.saveAsResources.placeholder(),
    maxLength: 30,
    onChange: saveDialogLayoutNameChange,
    ref: inputRef,
    autoFocus: true //works?
    ,
    sx: inputStyles,
    id: "save-layout-input"
  }), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end",
    mt: "md",
    gap: "lg"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    id: "dialog-cancel-save-layout",
    onClick: close,
    height: "button.height"
  }, props.saveAsResources.cancel()), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    id: "export-dialog-save-layout",
    onClick: saveClick,
    disabled: !isValid,
    height: "button.height",
    sx: buttonStyles
  }, props.saveAsResources.confirm()))))));
});
SaveAsDialog.displayName = 'SaveAsDialog';

export { SaveAsDialog };
//# sourceMappingURL=save-as-dialog.esm.js.map
